/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type PosProfileDTO = {
    accountNumber?: string;
    id?: number;
    outletId?: string;
    outletName?: string;
    status?: PosProfileDTO.status;
    terminalId?: string;
};

export namespace PosProfileDTO {

    export enum status {
        ACTIVE = 'ACTIVE',
        INACTIVE = 'INACTIVE',
    }


}
